import { z } from "zod";

export const JurosMultaContratoSchema = z.object({
    idContratoFinanceiro: z.number().optional().nullable(),

    percentualJuros: z.coerce.number().optional().nullable(),
    percentualMulta: z.coerce.number().optional().nullable(),


});

export type JurosMultaContratoForm = z.infer<typeof JurosMultaContratoSchema>;

export const defaultJurosMultaContratoForm: Partial<JurosMultaContratoForm> = {
    percentualJuros: 0,
    percentualMulta: 0,

}